import type { ReactNode } from 'react';

export const MODAL_INPUT_CLASSES =
    'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 text-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-gray-50 disabled:text-gray-400';

interface ModalFieldProps {
    htmlFor: string;
    label: string;
    required?: boolean;
    hint?: ReactNode;
    hintTone?: 'muted' | 'warning' | 'error';
    children: ReactNode;
}

const HINT_TONES = {
    muted: 'text-gray-400',
    warning: 'text-amber-600',
    error: 'text-red-500'
} as const;

export function ModalField({
    htmlFor,
    label,
    required = false,
    hint,
    hintTone = 'muted',
    children
}: ModalFieldProps) {
    return (
        <div>
            <label htmlFor={htmlFor} className="block text-xs font-semibold text-gray-700 mb-1">
                {label} {required ? '*' : ''}
            </label>
            {children}
            {hint && <p className={`text-xs mt-1 ${HINT_TONES[hintTone]}`}>{hint}</p>}
        </div>
    );
}
